export class Error {
	constructor({
		// unique error code
		code,

		// see ErrorType.enum.js
		type,

		// the matching string used for searching in the server error description when type is Custom
		searchCriteria,

		// the title for the error dialog
		title,

		// the body message in the error dialog
		description,

		// the css class added to the dialog
		styleCls,

		// primary button for the error dialog
		primaryButtonType,
		primaryButtonText,
		primaryButtonOnClick,

		// secondary button for the error dialog
		secondaryButtonType,
		secondaryButtonText,
		secondaryButtonOnClick,

		// type of custom error to be handled by ErrorService - i.e. validation, plugin, scale, shipstationApi, etc.
		custom,

		// url of the request that caused the error
		url,
	}) {
		Object.assign(this, {
			code,
			type,
			searchCriteria,
			title,
			description,
			styleCls,
			primaryButtonType,
			primaryButtonText,
			primaryButtonOnClick,
			secondaryButtonType,
			secondaryButtonText,
			secondaryButtonOnClick,
			custom,
			url,
		});
	}
}
